import RightArrow from "elements/RightArrow";
import TenantAPI from "api/api/TenantAPI";
import React from "react";
import { useState, useLayoutEffect, useRef } from "react";
import { CSVLink } from "react-csv";
import { Button, FormGroup, Input, Modal } from "reactstrap";

const DownloadTemplateModal = ({ open, handleClose, moduleAPIName }) => {
  const [templateFileName, setTemplateFileName] = useState("");
  const [csvHeaders, setCSVHeaders] = useState(null);
  const templateCsvLinkRef = useRef();

  const onClose = () => {
    setTemplateFileName("");
    setCSVHeaders(null);
    handleClose();
  };

  useLayoutEffect(() => {
    if (csvHeaders !== null) {
      setTimeout(() => {
        templateCsvLinkRef.current.link.click();
        onClose();
      });
    }
  }, [csvHeaders]);

  const downloadTemplate = () => {
    TenantAPI.getCSVTemplate(moduleAPIName, "template.csv", undefined).then(
      (data) => {
        let fields = data.data.split(",");

        let payload = [];

        for (let i = 0; i < fields.length; i++) {
          payload.push({
            label: fields[i],
            key: fields[i],
          });
        }

        setCSVHeaders(payload);
      },
      (e) => console.error(e)
    );
  };

  return (
    <Modal className="" isOpen={open} toggle={onClose}>
      <div className="modal-header">
        <h5 className="modal-title" id="exampleModalLabel">
          Download CSV Template
        </h5>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={onClose}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <div className="modal-body">
        <FormGroup>
          <h5>File Name</h5>
          <Input
            className="form-control"
            value={templateFileName}
            onChange={(e) => setTemplateFileName(e.target.value)}
            placeholder="template.csv"
          ></Input>
        </FormGroup>
      </div>
      <div className="modal-footer">
        <Button
          color="secondary"
          data-dismiss="modal"
          type="button"
          onClick={onClose}
        >
          Close
        </Button>
        <Button
          color=""
          disabled={!templateFileName}
          className="btn-primary"
          type="button"
          onClick={downloadTemplate}
        >
          Download <RightArrow></RightArrow>
        </Button>
        <CSVLink
          headers={csvHeaders}
          filename={templateFileName}
          data={[]}
          ref={templateCsvLinkRef}
          target="_blank"
        />
      </div>
    </Modal>
  );
};

export default DownloadTemplateModal;
